import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { Body, Button, Heading } from 'copilot-design-system';
import { useTranslation } from 'react-i18next';

export const FileClientPermissionChangeConfirmationDialog = ({
  open,
  onConfirm,
  onClose,
  isLocking,
  folderName,
}: {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isLocking: boolean;
  folderName?: string;
}) => {
  const { t } = useTranslation();

  const description = t(($) =>
    isLocking
      ? $.messages.file_permission_change.locking_description
      : $.messages.file_permission_change.unlocking_description,
  );

  const title = folderName
    ? t(
        ($) =>
          isLocking
            ? $.messages.file_permission_change.lock_access_title
            : $.messages.file_permission_change.unlock_access_title,
        { folderName },
      )
    : t(($) =>
        isLocking
          ? $.messages.file_permission_change.lock_access_label
          : $.messages.file_permission_change.unlock_access_label,
      );

  const cancelLabel = t(
    ($) => $.messages.file_permission_change.cancel_button_label,
  );

  const confirmLabel = t(
    ($) => $.messages.file_permission_change.confirm_button_label,
  );

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Heading size="lg">{title}</Heading>
      </DialogTitle>
      <DialogContent>
        <Body>{description}</Body>
      </DialogContent>
      <DialogActions className="px-6 pb-5">
        <Button variant="secondary" onClick={onClose} label={cancelLabel} />
        <Button variant="primary" onClick={onConfirm} label={confirmLabel} />
      </DialogActions>
    </Dialog>
  );
};
